import { PropsWithChildren, forwardRef } from 'react';
import Box from '@bridebook/ui/src/components/fela/Box';
import { FelaCSS } from '@bridebook/ui/src/components/fela/flowtypes';
import mergeStyles from '@bridebook/ui/src/fela-utils/merge-styles';
import componentStyles from './tabs.style';

interface IProps extends PropsWithChildren {
  stretch?: boolean;
  tabGap?: number;
  style?: FelaCSS;
  onMouseLeave?: () => void;
}

/**
 * @deprecated
 * Use Tabs from bridebook/aura instead.
 */
const Tabs = forwardRef<HTMLElement, IProps>(
  ({ stretch = true, tabGap = 0, style = {}, children, ...restProps }, ref) => {
    const styles = componentStyles({ tabGap, stretch });

    return (
      <Box style={mergeStyles([styles.wrapper, style])} setRef={ref} {...restProps}>
        {children}
      </Box>
    );
  },
);

Tabs.displayName = 'Tabs';

export default Tabs;
